import { render, staticRenderFns } from "./CardStorageConsent.vue?vue&type=template&id=b08cdb06"
import script from "./CardStorageConsent.vue?vue&type=script&lang=js"
export * from "./CardStorageConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports